import axios from '../Backend';
import { convertDateTimeToApplicationTime } from '../../util/functions'

export const getMsgs = async (data) => {
    let queryString = ''
    if (data && typeof data === 'object') {
        Object.keys(data).forEach(key => {
            console.log(data[key])
            queryString += `${queryString ? '&' : '?'}${key}=${data[key]}`
        })
    }
    const res = await axios.get(`/api/v2/msg${queryString}${queryString ? '&sort=msgTime' : '?sort=msgTime'}`)
    return res.data.data.data
}

export const getMsgsToCsvFormat = async (data) => {
    let columnsarr = ['msgTime', 'clientName', 'displayName', 'msgType', 'isAgent', 'msg']
    let columns = columnsarr.join(',')
    let msgsCsvCopy = columns + '\n'
    const msgs = await getMsgs(data)
    msgs.forEach(msg => {
        let row = columnsarr.reduce((prevValue, column) => {
            return `${prevValue}${msg[column] ? msg[column] : ''},`
        }, '')
        row = row.slice(0, -1)
        msgsCsvCopy = msgsCsvCopy + row + '\n'
    })
    return msgsCsvCopy.replace('msgTime', 'זמן הודעה')
        .replace('clientName', 'מזהה שיחה')
        .replace('displayName', 'שם תצוגה')
        .replace('msgType', 'ערוץ')
        .replace('isAgent', 'האם נציג')
        .replace('msg', 'הודעה')
}

export const formatMsgArrToClipboard = async (data, msgType, name) => {
    const msgs = await getMsgs(data)
    let date = ''
    let copyToClipboard = `היצוא בוצע בתאריך ${convertDateTimeToApplicationTime(new Date())} ערוץ ${msgType}\n`
    copyToClipboard += `${'▔'.repeat(45)}\n`
    let counter = 1
    msgs.forEach(msg => {
        if (msg.style === 'note') return
        const msgTime = new Date(msg.msgTime)
        if (date !== msgTime.toDateString()) {
            date = msgTime.toDateString()
            copyToClipboard += `=> תאריך: ${msgTime.getDate()}.${msgTime.getMonth() + 1}.${msgTime.getFullYear()} <=\n`
            copyToClipboard += `${'▔'.repeat(21)}\n`
        }
        let senderDetails = msg.isAgent ? `נציג , ${msg.agentName}` : `לקוח , ${msg.clientName} ${name ? `, ${name}` : ' '}`

        copyToClipboard += `${counter}) ${msgTime.getHours()}:${msgTime.getMinutes()}:${msgTime.getSeconds()} ::: ${senderDetails} \n`
        copyToClipboard += `${msg.msg}\n`
        counter++

    })
    // console.log(copyToClipboard)
    return copyToClipboard
}


export const deleteMsgById = async (msgId) => {
    try {

        axios.delete('/msgs/' + msgId);
        return true
    } catch (e) {
        if (e.response && e.response.data) {
            console.log(e.response.data)
            return false
        }
    }
}

export const patchMsgById = async (msgId, data) => {
    const res = axios.patch(`/api/v2/msg/${msgId}`, data);
    const resData = res.data
    return resData
}

export const UpdateMsgById = async (msgId, newMsgText) => {
    try {
        let sendObj = { msgId, newMsgText }
        axios.put('/msgs/', sendObj);
        return true
    } catch (e) {
        if (e.response && e.response.data) {
            console.log(e.response.data)
            return false
        }
    }
}

export const addMsg = async (clientName, msgType, msgBody, msgStyle) => {
    const bodyObj = {
        clientName,
        msgType,
        msgBody,
        msgStyle
    }
    axios.post('/api/v2/msg', bodyObj);
}


export const sendMultipleMessages = async (payload) => {
    try {
        const response = await axios.post('/api/v2/msg/send-multiple-msgs',  payload );
        return response.data;
    } catch (e) {
        console.log(e.response?.data?.msg)
    }
}